<template>
  <div
    class="cbg-white-container blog-listing-main input-container theme--light v-card p-16 border-card"
  >
    <div
      class="Head-div p-3 d-flex justify-content-between align-items-center border-bottom row my-0"
    >
      <h4 class="mb-0">Create Blog</h4>
      <div>
        <v-btn class="py-2" @click="goBack()" outlined text>
          <v-icon left>mdi-arrow-left-bold</v-icon>BACK
        </v-btn>
      </div>
    </div>
    <CCol class="col-sm-12 p-0 row m-0">
      <CCol sm="6">
        <label for>Title</label>
        <input
          v-model="blogFormData.title"
          @keydown.space="preventEmptySpace"
          type="text"
          placeholder="Title"
          class="form-control"
        />
        <span
          v-if="blogFormData.title === '' && alert === true"
          class="text-danger required-fields"
        >{{ requiredAlert }}</span>
      </CCol>
      <CCol sm="6">
        <label for>Upload Cover Image</label>
        <file-upload
          :media="'image'"
          :accept="accepted"
          label="upload"
          :src="docLink"
          :role="'patient'"
          :multiple="false"
          :module="'referred'"
          :drop="true"
          :isBlogImage="true"
          @uploaded="fileUploaded"
          :uploadFileToServer="uploadToServer"
          :uploadedImg="uploadedImg"
          @removeImage="deleteImg"
        ></file-upload>
        <span
          v-if="uploadedImgFullUrl[0] == undefined && alert === true"
          class="text-danger required-fields"
        >{{ requiredAlert }}</span>
      </CCol>
      <CCol sm="6">
        <label for class="col-sm-12 p-0 d-just-space">
          Short Description
          <span>{{ count }} of 150</span>
        </label>

        <textarea
          v-model="blogFormData.short_description"
          @keydown.space="preventEmptySpace"
          type="text"
          class="form-control"
          placeholder="Enter Short Description"
          rows="5"
          maxlength="150"
        ></textarea>
        <span
          v-if="blogFormData.short_description === '' && alert === true"
          class="text-danger required-fields"
        >{{ requiredAlert }}</span>
      </CCol>

      <CCol sm="6">
        <chip-combobox
          :tags="blogFormData.tags"
          :required="false"
          :requiredAlert="'Please select at least one tag'"
          @update:prop="value => blogFormData.tags = value"
        ></chip-combobox>
      </CCol>

      <CCol sm="12">
        <h3>Content</h3>
        <editor :model-value="blogFormData.description" @update:modelValue="updateDescripiton" />
        <span
          v-if="descriptionAlert === true && alert === true"
          class="text-danger required-fields"
        >{{ requiredAlert }}</span>
      </CCol>
      <CCol sm="12" md="12" class="flex-end mob-f-s flex-dir-col">
        <v-btn
          v-if="Object.keys(this.$route.params).length !== 0"
          color="error"
          class="mr-4 xs-mb-10 xs-mr-0"
          @click="openSwalDelete($route.params.id)"
        >Delete</v-btn>
        <v-btn v-else color="error" class="mr-4 xs-mb-10 xs-mr-0" @click="openSwalReset()">Discard</v-btn>
        <v-btn
          color="success"
          class="mr-4 xs-mb-10 xs-mr-0"
          @click="validateBeforeSubmit('publish')"
        >Publish</v-btn>
        <v-btn
          color="success"
          class="xs-mb-10 xs-mr-0"
          outlined
          @click="saveAsDraft('draft')"
        >Save as draft</v-btn>
      </CCol>
    </CCol>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import config from "@/config.js";
import "@/assets/scss/_blogs.scss";
import FileUpload from "@/components/FileUpload.vue";
const Datepicker = () => import("v-calendar/lib/components/date-picker.umd");
import Editor from "./../../components/Editor/Editor.vue";
import goBack from "@/methods/utilities.vue";
import chipCombobox from "@/components/chipCombobox.vue";
export default {
  mixins: [goBack],
  components: {
    Datepicker,
    FileUpload,
    Editor,
    chipCombobox,
  },
  watch: {
    "blogFormData.short_description": function(newValue) {
      if (newValue) {
        this.count = newValue.length;
      }
    }
  },
  data() {
    return {
      // tags: [],
      // description:
      //   "<p>A Vue.js wrapper component for tiptap to use <code>v-model</code>.</p><p></p>",
      accepted: "image/png,image/jpg,image/jpeg",
      showLoader: false,
      uploadedImg: [],
      uploadedImgFullUrl: [],
      docLink: null,
      blogFormData: {
        title: "",
        short_description: "",
        description: "",
        tags: []
      },
      alert: false,
      requiredAlert: "This field is required.",
      count: 0,
      descriptionAlert: false,
      uploadToServer: false
    };
  },
  computed: {
    isTitleEmpty() {
      return this.blogFormData.title === "";
    },
    isDescriptionEmpty() {
      return (
        this.blogFormData.description == "" ||
        this.blogFormData.description == "<p></p>" ||
        this.blogFormData.description == "<p> </p>" ||
        this.blogFormData.description == "<h1></h1>" ||
        this.blogFormData.description == "<h1> </h1>" ||
        this.blogFormData.description == "<h2></h2>" ||
        this.blogFormData.description == "<h2> </h2>"
      );
    },
    isShortDescriptionEmpty() {
      return this.blogFormData.short_description === "";
    },
    isTagsEmpty() {
      return this.blogFormData.tags.length === 0;
    },
    isImageEmpty() {
      return this.uploadedImgFullUrl[0] == undefined;
    }
  },
  mounted() {
    if (Object.keys(this.$route.params).length !== 0) {
      this.getBlogDetails(this.$route.params);
    }
  },
  methods: {
    preventEmptySpace(e) {
      if (!e.target.value) e.preventDefault();
      else if (e.target.value[0] == " ")
        e.target.value = e.target.value.replace(/^\s*/, "");
    },
    getBlogDetails(id) {
      let url = `${config.BASE_URL}api/v2/admin/blogs/${id.id}/admin`;
      this.$http.get(url, {}).then(response => {
        if (response.body.status) {
          if (response.body.data) {
            this.blogFormData = { ...response.body.data };
            let imageName = this.blogFormData.cover_photo.split("/");
            if (imageName.length > 0) {
              this.uploadedImg = [imageName[3]];
              this.uploadedImgFullUrl[0] = this.blogFormData.cover_photo;
            }
          } else {
            this.blogDetails = {};
          }
        }
      });
    },
    updateDescripiton(description) {
      this.blogFormData.description = description;
    },
    fileUploaded(files, uploaded, name) {
      this.showLoader = true;
      this.uploadToServer = true;
      if (uploaded) {
        this.uploadToServer = false;
        this.uploadedImgFullUrl = files;
        this.uploadedImg = files.map(el => {
          return el.split("/").pop();
        });

        this.showLoader = false;
      }
    },

    deleteImg() {
      this.uploadedImg = [];
      this.uploadedImgFullUrl = [];
    },

    saveAsDraft(status) {
      if (
        this.isTitleEmpty &&
        this.isDescriptionEmpty &&
        this.isShortDescriptionEmpty &&
        this.isTagsEmpty &&
        this.isImageEmpty
      ) {
        this.$swal({
          text: "At least one field required",
          icon: "info",
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonText: "Ok"
        });
        return;
      }
      if (Object.keys(this.$route.params).length === 0) {
        if (status === "publish") {
          this.openSwal(status);
        } else {
          this.createBlog(status);
        }
      } else {
        if (status === "publish") {
          this.openSwal(status);
        } else {
          this.updateBlog(status);
        }
      }
    },

    validateBeforeSubmit(status) {
      // var doc = new DOMParser().parseFromString(this.blogFormData.description, "text/xml");
      // if(doc.firstChild.innerHTML == ' '){
      //   console.log('==oee hoeee===')
      // }
      if (
        this.blogFormData.description == "" ||
        this.blogFormData.description == "<p></p>" ||
        this.blogFormData.description == "<p> </p>" ||
        this.blogFormData.description == "<h1></h1>" ||
        this.blogFormData.description == "<h1> </h1>" ||
        this.blogFormData.description == "<h2></h2>" ||
        this.blogFormData.description == "<h2> </h2>"
      ) {
        this.descriptionAlert = true;
        this.blogFormData.description = "";
      }
      if (
        this.blogFormData.title === "" ||
        this.blogFormData.description == "" ||
        this.blogFormData.description == "<p></p>" ||
        this.blogFormData.description == "<p> </p>" ||
        this.blogFormData.description == "<h1></h1>" ||
        this.blogFormData.description == "<h1> </h1>" ||
        this.blogFormData.description == "<h2></h2>" ||
        this.blogFormData.description == "<h2> </h2>" ||
        this.blogFormData.short_description === "" ||
        this.blogFormData.tags.length === 0 ||
        this.uploadedImgFullUrl[0] == undefined
      ) {
        this.alert = true;
        return false;
      } else {
        if (Object.keys(this.$route.params).length === 0) {
          if (status === "publish") {
            this.openSwal(status);
          } else {
            this.createBlog(status);
          }
        } else {
          if (status === "publish") {
            this.openSwal(status);
          } else {
            this.updateBlog(status);
          }
        }
      }
    },
    createBlog(status) {
      let obj = {
        title: this.blogFormData.title,
        cover_photo: this.uploadedImgFullUrl[0],
        short_description: this.blogFormData.short_description,
        description: this.blogFormData.description,
        tags: this.blogFormData.tags,
        status: status
      };
      let url = `${config.BASE_URL}api/v2/admin/blogs`;
      this.$http.post(url, obj).then(response => {
        if (!!response.ok) {
          if (status === "publish") {
            Swal.fire({
              title: "Blog Published Successfully",
              icon: "success",
              showCancelButton: false,
              confirmButtonText: "Ok"
            }).then(result => {
              if (result.isConfirmed) {
                this.goTo("/blogs-listing");
              }
            });
          } else {
            Swal.fire({
              title: "Blog Saved Successfully",
              icon: "success",
              showCancelButton: false,
              confirmButtonText: "Ok"
            }).then(result => {
              if (result.isConfirmed) {
                this.goTo("/blogs-listing");
              }
            });
          }
        }
      });
    },
    updateBlog(status) {
      let obj = {
        title: this.blogFormData.title,
        cover_photo: this.uploadedImgFullUrl[0],
        short_description: this.blogFormData.short_description,
        description: this.blogFormData.description,
        tags: this.blogFormData.tags,
        status: status
      };
      let url = `${config.BASE_URL}api/v2/admin/blogs/${this.$route.params.id}`;
      this.$http.post(url, obj).then(response => {
        if (!!response.ok) {
          if (status === "publish") {
            Swal.fire({
              title: "Blog Published Successfully",
              icon: "success",
              showCancelButton: false,
              confirmButtonText: "Ok"
            }).then(result => {
              if (result.isConfirmed) {
                this.goTo("/blogs-listing");
              }
            });
          } else {
            Swal.fire({
              title: "Blog Saved Successfully",
              icon: "success",
              showCancelButton: false,
              confirmButtonText: "Ok"
            }).then(result => {
              if (result.isConfirmed) {
                this.goTo("/blogs-listing");
              }
            });
          }
        }
      });
    },
    openSwal(status) {
      Swal.fire({
        title: "Are you sure you want to Publish this blog",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      }).then(result => {
        if (result.isConfirmed) {
          if (Object.keys(this.$route.params).length === 0) {
            this.createBlog(status);
          } else {
            this.updateBlog(status);
          }
        }
      });
    },
    openSwalDelete(id) {
      Swal.fire({
        title: "Are you sure you want to Delete this blog",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      }).then(result => {
        if (result.isConfirmed) {
          this.deleteBlog(id);
        }
      });
    },
    deleteBlog(id) {
      let url = `${config.BASE_URL}api/v2/admin/blogs/${id}`;
      this.$http.delete(url, {}).then(response => {
        if (!!response.ok) {
          Swal.fire({
            title: "Blog Deleted Successfully",
            icon: "success",
            showCancelButton: false,
            confirmButtonText: "Ok"
          }).then(result => {
            if (result.isConfirmed) {
              this.goTo("/blogs-listing");
            }
          });
        }
      });
    },
    openSwalReset() {
      Swal.fire({
        title: "Are you sure you want to Discard this blog",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      }).then(result => {
        if (result.isConfirmed) {
          this.resetBlogForm();
          this.goTo("/blogs-listing");
        }
      });
    },
    resetBlogForm() {
      this.blogFormData.title = "";
      this.blogFormData.description = "<p></p>";
      this.blogFormData.short_description = "";
      this.blogFormData.tags.length = 0;
      this.deleteImg();
    },
    goTo(url) {
      this.$router.push(url);
    }
  }
};
</script>
